import { Pipe, PipeTransform } from '@angular/core';
import { FilledPatientAssessmentRow } from '../models/filled-patient-assessment';

@Pipe({ name: 'filterAssessmentsByStatus' })
export class FilterAssessmentsByStatusPipe implements PipeTransform {
  transform(assessmentList: FilledPatientAssessmentRow[], status: string): FilledPatientAssessmentRow[] {
    return (assessmentList || []).filter((assessment) => status.includes(assessment.status));
  }
}
